import { convertStylesheetResponse, useHead, useRoute, useRuntimeConfig, useSeoMeta } from '#imports';
import { escapeJsonLd, listingCanonical, robotsContent } from '~/utils/seoHead';

export function loadHeadMeta(pageData) {
  const { seo } = pageData;
  const config = useRuntimeConfig();
  const canonical = seo?.canonical || listingCanonical(config.public.baseUrl, useRoute().path);

  useHead({
    title: seo.title ?? pageData.name,
    link: [
      ...convertStylesheetResponse(pageData.enqueuedStylesheets),
      { rel: 'canonical', href: canonical, key: 'canonical' },
    ],
    script: pageData.jsonLd ? [{
      id: 'json-ld',
      type: 'application/ld+json',
      innerHTML: escapeJsonLd(pageData.jsonLd),
    }] : [],
  });

  if (seo) {
    useSeoMeta({
      title: seo.title,
      ogTitle: seo.title,
      twitterTitle: seo.title,
      description: seo.metaDesc,
      ogDescription: seo.metaDesc,
      twitterDescription: seo.metaDesc,
      twitterCard: 'summary_large_image',
      author: pageData.author?.node?.name,
      ogType: seo.opengraphType,
      ogUrl: canonical,
      robots: robotsContent(seo),
      ogLocale: 'en_US',
      ogSiteName: seo.opengraphSiteName,
      twitterSite: seo.opengraphSiteName,
      publisher: seo.opengraphPublisher,
      articlePublishedTime: seo.opengraphPublishTime,
      ogImage: {
        url: seo.opengraphImage?.mediaItemUrl,
        alt: seo.opengraphImage?.altText,
        secureUrl: seo.opengraphImage?.mediaItemUrl,
      },
      twitterImage: seo.opengraphImage?.mediaItemUrl,
      twitterImageAlt: seo.opengraphImage?.altText,
    });
  }
}